// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"560":"1eb87af8","626":"2af349b8","897":"20b85b13","930":"11597a68"}[chunkId] + ".css";
};